import {
  InputAdornment as MuiInputAdornment,
  InputAdornmentProps as MuiInputAdornmentProps,
  styled,
} from "@mui/material";

const StyledInputAdornment = styled(MuiInputAdornment)(() => ({
  // ... existing styles
}));

interface InputAdornmentProps extends MuiInputAdornmentProps {
  children: React.ReactNode;
}

export const InputAdornment: React.FC<InputAdornmentProps> = ({ children, ...props }) => {
  return <StyledInputAdornment {...props}> {children}</StyledInputAdornment>;
};

export default InputAdornment;
